<template>
  <div :class="{'hidden':hidden}" class="pagination-container">
    <el-pagination
      :background="background"
      :current-page="currentPage"
      :layout="layout"
      :page-size="pageSize"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>

export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50]
      }
    },
    layout: {
      type: String,
      // default: 'total, sizes, prev, pager, next, jumper'
      default: 'prev, pager, next'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        console.log('val',val);
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        console.log('val',val);
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('update:limit', val)
      this.$emit('pagination', {current: this.currentPage, size: val})
    },
    handleCurrentChange(val) {
      this.$emit('update:page', val)
      this.$emit('pagination', {current: val, size: this.pageSize})
    }
  }
}
</script>

<style scoped>
.pagination-container {
  background: #fff;
  padding: 10px 0;
  text-align: center;
  background: none
}

.pagination-container.hidden {
  display: none;
}

.pagination-container :deep .el-pagination__sizes,
.pagination-container :deep .el-pagination .el-select .el-input {
  margin-right: 0;
}

.pagination-container :deep .el-pagination {
  padding-right: 0;
}
</style>
